jQuery( '#caseStudyGallery' ).slick( {
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    centerMode: true,
    infinite: true,
    arrows: true,
    prevArrow: jQuery( ".case-study-gallery-prev" ),
    nextArrow: jQuery( ".case-study-gallery-next" ),
    slidesToShow: 1,
    centerPadding: '200px',
    responsive: [
        {
            breakpoint: 992,
            settings: {
                centerPadding: '100px',
            }
        },
        {
            breakpoint: 600,
            settings: {
                centerPadding: '50px',
            }
        }
    ]
} );

jQuery( '.single-post .case-study-banner .arrow-container .arrow-animation-button' ).on( 'click', function() {
    var bannerHeight = jQuery( '.single-post .case-study-banner' ).height();
    bannerHeight = bannerHeight + 100;
    jQuery( 'html,body' ).animate( {
        scrollTop: '+=' + bannerHeight + 'px'
    }, 1 );
} );
